import { render } from "./learning-map-teacher.vue?vue&type=template&id=1a91e966&ts=true"
import script from "./learning-map-teacher.vue?vue&type=script&lang=ts"
export * from "./learning-map-teacher.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__